import Form from "./Form";
import FormSection from "./FormSection";
import Input from "./Input";
import InputSelect from "./InputSelect";
import InputNumber from "./InputNumber";
import ToogleButtons from "./ToggleButtons";
import RadioButtons from "./RadioButtons";

Form.Input = Input;
Form.InputSelect = InputSelect;
Form.InputNumber = InputNumber;
Form.ToogleButtons = ToogleButtons;
Form.Section = FormSection;
Form.RadioButtons = RadioButtons;

export default Form;
